import { render, staticRenderFns } from "./SampleHistogram.vue?vue&type=template&id=5512d5bc&scoped=true&"
import script from "./SampleHistogram.vue?vue&type=script&lang=js&"
export * from "./SampleHistogram.vue?vue&type=script&lang=js&"
import style0 from "./SampleHistogram.vue?vue&type=style&index=0&id=5512d5bc&scoped=true&lang=css&"
import style1 from "./SampleHistogram.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512d5bc",
  null
  
)

export default component.exports